import { render } from "./MemberCard.vue?vue&type=template&id=5d533f9b&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"

import "./MemberCard.vue?vue&type=style&index=0&id=5d533f9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d533f9b"

export default script